/* eslint-disable */
export const EN = {
}
